import React from 'react';
import LayoutCustomerSuccess from 'src/components/LayoutCustomerSuccess/LayoutCustomerSuccess';
import ProspectsContainer from 'src/components/Prospects/ProspectsContainer/ProspectsContainer';

const Prospects = () => (
    <LayoutCustomerSuccess>
        <ProspectsContainer />
    </LayoutCustomerSuccess>
);

export default Prospects;
